import { hexToRgb } from "./colorSystemPresentation.mjs";

export const normalizePaletteHex = (value) => String(value || "").trim().toUpperCase();
export const validPaletteHex = (value) => /^#[0-9A-F]{6}$/.test(normalizePaletteHex(value));

export const paletteLab = (hex) => {
  const rgb = hexToRgb(hex);
  const linear = (channel) => {
    const value = channel / 255;
    return value <= 0.04045 ? value / 12.92 : ((value + 0.055) / 1.055) ** 2.4;
  };
  const r = linear(rgb.r); const g = linear(rgb.g); const b = linear(rgb.b);
  const xyz = [(0.4124564*r + 0.3575761*g + 0.1804375*b) / 0.95047,
    0.2126729*r + 0.7151522*g + 0.0721750*b,
    (0.0193339*r + 0.1191920*g + 0.9503041*b) / 1.08883];
  const [x, y, z] = xyz.map((value) => value > (6/29) ** 3
    ? value ** (1/3) : value / (3*(6/29)**2) + 4/29);
  return [116*y - 16, 500*(x-y), 200*(y-z)];
};

export const paletteDifference = (first, second) => {
  const a = paletteLab(first); const b = paletteLab(second);
  return Math.sqrt(a.reduce((sum, value, i) => sum + (value - b[i]) ** 2, 0));
};

// D65 Lab inverse; reject out-of-gamut candidates rather than silently clipping hue.
export function paletteHexAtLightness(hex, lightness) {
  const [, a, b] = paletteLab(hex);
  const y = (lightness + 16) / 116;
  const inverse = (v) => v > 6/29 ? v ** 3 : 3 * (6/29) ** 2 * (v - 4/29);
  const x = 0.95047 * inverse(y + a / 500); const yy = inverse(y); const z = 1.08883 * inverse(y - b / 200);
  const channels = [3.2404542*x - 1.5371385*yy - 0.4985314*z,
    -0.969266*x + 1.8760108*yy + 0.041556*z,
    0.0556434*x - 0.2040259*yy + 1.0572252*z];
  if (channels.some((v) => v < 0 || v > 1)) return null;
  return "#" + channels.map((v) => Math.round(255 * (v <= 0.0031308 ? 12.92*v : 1.055*v**(1/2.4) - 0.055)).toString(16).padStart(2, "0")).join("").toUpperCase();
}

export function paletteDraftError(colors, selectedId, draft) {
  if (!validPaletteHex(draft.hex)) return "Введи HEX из шести символов, например #39241A.";
  if (!draft.name.trim()) return "Добавь название цвета.";
  if (draft.name.trim().length > 120) return "Название должно быть не длиннее 120 символов.";
  const neighbors = colors.filter((color) => color.stable_id !== selectedId);
  if (neighbors.some((color) => color.hex === normalizePaletteHex(draft.hex)))
    return "Этот HEX уже есть в палитре. Выбери другой оттенок.";
  if (neighbors.some((color) => color.name.trim().toLocaleLowerCase("ru") === draft.name.trim().toLocaleLowerCase("ru")))
    return "Такое название уже есть. Назови оттенки по-разному.";
  return "";
}

export function paletteNearWarnings(colors) {
  const warnings = [];
  colors.forEach((first, index) => {
    colors.slice(index + 1).forEach((second) => {
      if (!validPaletteHex(first.hex) || !validPaletteHex(second.hex) || first.hex === second.hex) return;
      const distance = paletteDifference(first.hex, second.hex);
      if (distance < 10) warnings.push(`«${first.name}» и «${second.name}» очень близки. Их можно оставить, если каждому нужен свой смысл.`);
    });
  });
  return warnings;
}

